import currentTheme from './variation-current';
import swissTheme from './variation-swiss';
import neobankTheme from './variation-neobank';
import lumoTheme from './variation-lumo';

const themes = {
  current: currentTheme,
  swiss: swissTheme,
  neobank: neobankTheme,
  lumo: lumoTheme,
};

export const themeNames = {
  current: 'Integraal Bank',
  swiss: 'Berchtold & Cie',
  neobank: 'Nexora',
  lumo: 'Lumo',
};

export default themes;
